import { AuthService } from "./../../services/authService";
import { take } from "rxjs/operators";
import { ChartData, UserGroups } from "./../../../assets/config/models";
import { CoreService } from "./../../services/coreService";
import {
  Component,
  AfterViewInit,
  ViewChild,
  ChangeDetectorRef,
} from "@angular/core";

import { CommonModule, DatePipe } from "@angular/common";
import { BsDatepickerConfig } from "ngx-bootstrap/datepicker";
import { Router, RouterModule } from "@angular/router";
import { orderBy } from "lodash";
import { Database } from "@angular/fire/database";
import { ref, query, limitToLast, get, onValue } from "@angular/fire/database";
import { FormsModule } from "@angular/forms";
import { DashboardHeaderComponent } from "../../components/dashboard-header/dashboard-header.component";

declare var toastr: any;

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
  providers: [CoreService, DatePipe],
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, DashboardHeaderComponent],
})
export class HomeComponent {
  bsConfig: Partial<BsDatepickerConfig>;
  dateRange: Date[] = [];
  userDetails: any;
  visitorsLoading = false;
  revenuesLoading = false;
  capacityLoading = false;
  averageLoading = false;
  topupLoading = false;
  displayRevenuesDetails = false;
  displayVisitorsDetails = false;

  // Settings shared between charts.
  sharedSettings = {
    showXAxis: true,
    showYAxis: true,
    gradient: false,
    showLegend: false,
    showXAxisLabel: false,
    showYAxisLabel: true,
    roundDomains: false,
    animations: true,
    colorScheme: this.coreService.colorScheme,
  };
  passColor = this.coreService.passColor;

  visitorsChart!: ChartData[];
  visitorsHours: ChartData[] = [];
  // Data to check ID from title
  visitorsData!: any[];

  averageTimeChart: ChartData[] = [];

  topupChart: ChartData[] = [];

  revenueChart: ChartData[] = [];
  // Data to check ID from title
  revenueData!: any[];

  groupName: any;
  groupTypes = UserGroups;

  currentVisitorId: any;

  constructor(
    private coreService: CoreService,
    private datePipe: DatePipe,
    private changeDetector: ChangeDetectorRef,
    private db: Database,
    private router: Router,
    private authService: AuthService,
  ) {
    this.userDetails = JSON.parse(localStorage.getItem("user_details")!);

    this.groupName = this.userDetails.group;

    this.authService.navigateUser(this.userDetails);

    let endDate = new Date();
    let startDate = new Date();
    startDate.setDate(endDate.getDate() - 15);
    this.dateRange.push(startDate, endDate);
    this.bsConfig = this.coreService.bsConfig;
    this.configureCharts(this.dateRange);
  }

  onDateRangeChanged() {
    console.log(this.dateRange);
    this.configureCharts(this.dateRange);
  }

  async configureVisitorsChart() {
    let temp: ChartData[] = [];
    this.visitorsData.forEach((parking) => {
      let tempObject: ChartData = { name: parking.title, series: [] };
      tempObject.series!.push({
        name: "Registered",
        value: parking.registered_count,
      });

      tempObject.series!.push({
        name: "Unregistered",
        value: parking.unregistered_count,
      });
      temp.push(tempObject);
    });
    this.visitorsChart = [...temp];
  }

  async configureVisitorsDetailsChart(response: { parking_places: any[]; }) {
    let temp: ChartData[] = [];
    response.parking_places = orderBy(
      response.parking_places,
      (element) => element.day as any,
      ["asc"],
    );

    response.parking_places.forEach((parking: { day: string | number | Date; registered_count: any; unregistered_count: any; }) => {
      let tempObject: ChartData = {
        name: this.datePipe.transform(parking.day, "dd-MM-yyyy")!.toString(),
        series: [],
      };
      tempObject.series!.push({
        name: "Registered",
        value: parking.registered_count,
      });

      tempObject.series!.push({
        name: "Unegistered",
        value: parking.unregistered_count,
      });
      temp.push(tempObject);
    });
    this.visitorsChart = [...temp];
  }

  async configureAverageChart(average: { parking_places: any[]; }) {
    let temp: ChartData[] = [];
    average.parking_places.forEach((parking: { title: any; average_time: any; }) => {
      temp.push({
        name: parking.title,
        value: parking.average_time,
      });
    });
    this.averageTimeChart = [...temp];
  }

  async configureTopupChart(response: { parking_topups: any[]; }) {
    let temp: ChartData[] = [];
    response.parking_topups = orderBy(
      response.parking_topups,
      (element) => element.day as any,
      ["asc"],
    );

    response.parking_topups.forEach((topup: { day: string | number | Date; total_amount: any; }) => {
      temp.push({
        name: this.datePipe.transform(topup.day, "dd-MM-yyyy")!.toString(),
        value: topup.total_amount,
      });
    });
    this.topupChart = [...temp];
  }

  async configureRevenuesChart() {
    let temp: ChartData[] = [];

    this.revenueData.forEach((parking: { parking_place: any; beneficiary: any[]; }, parkingIndex: any) => {
      let tempObject: ChartData = { name: parking.parking_place, series: [] };
      parking.beneficiary.forEach((element: { name: any; amount: any; }) => {
        tempObject.series!.push({
          name: element.name,
          value: element.amount,
        });
      });
      temp.push(tempObject);
    });
    console.log("revenueChart", temp);
    this.revenueChart = [...temp];
  }

  async configureCharts(date: Date[]) {
    this.visitorsLoading = true;
    this.revenuesLoading = true;
    this.averageLoading = true;
    this.topupLoading = true;
    let average;
    let topup;
    try {
      [this.visitorsData, this.revenueData, average, topup] = await Promise.all(
        [
          this.coreService
            .GetVisitors(date)
            .then((response) => response.parking_places),
          this.coreService
            .GetRevenues(date)
            .then((response) => response.revenues),
          this.coreService.GetAverageTimeSpent(date),
          this.coreService.GetTopup(date),
        ],
      );
      await this.configureVisitorsChart();
      await this.configureRevenuesChart();
      await this.configureAverageChart(average);
      await this.configureTopupChart(topup);
    } catch (error: any) {
      console.log(error || error.message);
    } finally {
      this.visitorsLoading = false;
      this.revenuesLoading = false;
      this.averageLoading = false;
      this.topupLoading = false;
    }
  }

  async onSelectVisitorsChart(event: { series: any; }) {
    console.log(event);
    this.visitorsLoading = true;
    switch (this.displayVisitorsDetails) {
      case true: {
        this.displayVisitorsDetails = false;
        this.visitorsHours.length = 0;
        break;
      }
      case false: {
        this.displayVisitorsDetails = true;
        this.visitorsHours.length = 0;
        break;
      }
      case null: {
        this.displayVisitorsDetails = false;
        this.visitorsHours.length = 0;
        break;
      }
      default: {
        console.log("I shouldn't be here");
      }
    }
    console.log("displayVisistorsDetails: ", this.displayVisitorsDetails);
    let temp: ChartData[] = [];
    try {
      if (this.displayVisitorsDetails == null) {
        console.log(" current ID", this.currentVisitorId);
        console.log("test: ", event.series);

        const dbRef = ref(
          this.db,
          `/parking/${this.currentVisitorId}/dates/${event.series}`,
        );

        const q = query(dbRef, limitToLast(60 * 24));

        const snapshot = await get(q);

        const live_parking: any[] = snapshot.exists()
          ? Object.values(snapshot.val())
          : [];

        console.log("live parking visitors", live_parking);

        if (live_parking.length > 0) {
          temp.push({
            name: "Pass",
            series: [],
          });

          temp.push({
            name: "Unregistered",
            series: [],
          });

          live_parking.forEach((element: any) => {
            temp[0].series!.push({
              name: this.datePipe.transform(element.date, "HH:mm")!.toString(),
              value: element.registered_count,
            });

            temp[1].series!.push({
              name: this.datePipe.transform(element.date, "HH:mm")!.toString(),
              value: element.unregistered_count,
            });
          });

          this.visitorsHours = [...temp];
        } else {
          toastr.error("", "No Data to display", {
            timeOut: 2000,
          });
          this.displayVisitorsDetails = true;
        }
      } else if (this.displayVisitorsDetails == true) {
        this.currentVisitorId = this.visitorsData.find(
          (element) => element.title == event.series,
        ).id;

        let response = await this.coreService.GetVisitorsDetails(
          this.currentVisitorId,
          this.dateRange,
        );

        this.configureVisitorsDetailsChart(response);
      } else {
        await this.configureVisitorsChart();
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.visitorsLoading = false;
    }
  }

  async onSelectRevenuesChart(event: { series: any; }) {
    console.log(typeof event === "string");
    if (!(typeof event === "string")) {
      this.revenuesLoading = true;
      this.displayRevenuesDetails = this.displayRevenuesDetails ? false : true;
      let temp: ChartData[] = [];
      try {
        if (this.displayRevenuesDetails) {
          console.log(this.revenueData);
          let response = await this.coreService.GetRevenuesDetails(
            this.revenueData.find(
              (element: { parking_place: any }) =>
                element.parking_place == event.series,
            ).id,
            this.dateRange,
          );

          response.revenues = orderBy(
            response.revenues,
            (element) => element.day as any,
            ["asc"],
          );

          response.revenues.forEach((element: { day: string | number | Date; beneficiary: any[]; }, revenueIndex: any) => {
            let tempObject: ChartData = {
              name: this.datePipe
                .transform(element.day, "dd-MM-yyyy")!
                .toString(),
              series: [],
            };
            element.beneficiary.forEach((beneficiary: { name: any; amount: any; }, index: any) => {
              tempObject.series!.push({
                name: beneficiary.name,
                value: beneficiary.amount,
              });
            });
            temp.push(tempObject);
          });
          this.revenueChart = [...temp];
        } else {
          await this.configureRevenuesChart();
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.revenuesLoading = false;
      }
    }
  }
}
